<template>
<div>
    <div class="breadcrumbs" id="breadcrumbs">
      <router-link class="breadcrumb-link" to="/billing/">Billing & Payments</router-link> &gt;
      <router-link class="breadcrumb-link" to="/billing/transaction-history">Direct Payment Transaction History</router-link>
    </div>
    <h3>Direct Payment <span>Transaction History</span></h3><div class="ws-button" @click="modals.transactionHistoryExportModal = true">Generate CSV Export</div>

    <div v-if="index.data.length">
      <table id="transaction-history" class="worksends-table">
          <thead>
          <tr>
              <th class="field-id">ID</th>
              <th class="field-date">Date</th>
              <th class="field-type">Type</th>
              <th class="field-description">Description</th>
              <th class="field-campaign">Gift Campaign & Option</th>
              <th class="field-product">Product</th>
              <th class="field-price-exvat">Price (ex. VAT)</th>
              <th class="field-price">Price (inc. VAT)</th>
              <th class="field-amount">Amount Charged</th>
              <th class="field-balance">Payment Method</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in index.data" :data-type="item.type" :class="rowClasses(item)">
              <td class="field-id" ><div class="value">#{{ item.transaction_id }}</div></td>
              <td class="field-date" ><div class="value"><small>{{ item.date }}</small></div></td>
              <td class="field-type" ><div class="value">{{ item.type}}</div></td>
              <td class="field-description" ><div class="value"><b>{{ item.description }}</b></div><div v-if="item.reverted_at" class="reverted-text">Reverted {{ item.reverted_at }}</div></td>
              <td class="field-campaign" >
                  <div class="value" v-if="item.campaign"><b><a :href="'/campaigns/' + item.campaign.id">{{ item.campaign.name }}</a></b> / {{ item.option.name }}</div>
                  <div class="value" v-else-if="item.product"><i>Marketplace</i></div>
              </td>
              <td class="field-product" ><div class="value" v-if="item.product">{{ item.product.name }}</div></td>
              <td class="field-price-exvat"><div class="value" v-if="item.price_ex_vat">{{ item.price_ex_vat | toCurrency }}</div></td>
              <td class="field-price"><div class="value" v-if="item.price">{{ item.price | toCurrency }}</div></td>
              <td class="field-amount"><div class="value"><b>{{ positiveAmount(item.amount) | toCurrency }}</b></div></td>
              <td class="field-balance"><div class="value">{{ item.payment_method }}</div></td>
          </tr>
          </tbody>
      </table>

      <ws-table-meta :meta="index.meta" sum="You have % records in your transaction history."></ws-table-meta>

    </div>
    <div v-else>
      <div class="note" v-if="transactionHistoryLoaded">Your transaction history is empty.</div>
    </div>

    <transaction-history-export-modal v-if="modals.transactionHistoryExportModal" :last-transaction-id="index.data[0].transaction_id" @created="onTransactionHistoryExport" payment-method="direct"></transaction-history-export-modal>
</div>
</template>

<script>
import TransactionHistoryExportModal from '@/pages/billing/TransactionHistoryExportModal';

export default {
    description: "BillingTransactionHistoryDirect",
    components: {TransactionHistoryExportModal},
    data() {
      return {
          pageParams: {
              pageOptions: {page:1, sortBy:[], sortDesc:[], itemsPerPage: 10},
              search: {val: ""},
              filters: {}
          },
          transactionHistoryLoaded: false,
      }
    },
    methods: {
      async getPage(params) {
            await this.getPageHandler({
                waitName: 'transactions.index',
                action: 'fetchDirectTransactions', // vuex action
                pageParams: this.pageParams,
                isInit: params ? params.init : false, // parse from url query params
                pushRoute: false, // push pagination params and search q to route
                resetPagination: params ? params.resetPagination : false // new search input -> need to reset page & sorting
            });
            this.transactionHistoryLoaded = true;
        },
      async fetchData() {

      },
      onTransactionHistoryExport() {
        this.modals.transactionHistoryExport = false;
      },
      rowClasses(item) {
        let classes = [];
        if (item.amount === 0) classes.push('no-charge');
        if (item.reverted_at) classes.push('reverted');
        return classes.join(' ');
      },
      positiveAmount(amount) {
        if (amount > 0) return amount;
        else return 0 - amount;
      }
    },
    mounted() {
        this.pageParams.pageOptions.itemsPerPage = this.itemsPerPageCookie(this.$options.name);
        this.getPage({init:true});
        this.fetchData();
    },
    computed: {
        index () {
            return this.$store.state.transaction.directPaymentsIndex;
        },
        modals() {
            return this.$store.state.modals;
        },
    },
}
</script>

<style scoped>

</style>
